import React from "react";
import { useField, useFormikContext } from "formik";
import { TimePicker } from "antd";
import dayjs from "dayjs";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control"];

  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function TimePickerField({ ...props }) {
  const { setFieldValue, errors, touched } = useFormikContext();

  const [field] = useField(props);

  return (
    <>
      <div>{props.label && <label>{props.label}</label>}</div>

      <TimePicker
        needConfirm={false}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        style={{ width: "100%" }}
        showNow={false}
        format="hh:mm a"
        use12Hours={true}
        onChange={(value) => {
          setFieldValue(field.name, value ? value.format("HH:mm") : "", true);
        }}
        value={field.value ? dayjs(`2000-01-01T${field.value}`) : null}
      />

      {errors[field.name] && touched[field.name] && (
        <div className="invalid-datepicker-feedback">
          {errors[field.name].toString()}
        </div>
      )}
    </>
  );
}
